<template>
    <section id="footer" class="text-center mt-2">
        <div class="copyright">
            <div>Please email <a :href="`mailto:${email}`" class="nav-link">{{ email }}</a> for assistance or to request a call back.</div>
            <div>© {{ year }} {{ appName }}. All Rights Reserved</div>
        </div>
        <div class="footer-nav">
            <inertia-link href="privacy-policy" class="nav-link">Privacy Policy</inertia-link>
            | <inertia-link href="terms-of-use" class="nav-link">Terms of Use</inertia-link>
        </div>
    </section>
</template>
<script>
export default {
    data() {
        return {
            appName: window.laravel.appName,
            year: new Date().getFullYear(),
            email: this.$page.props.clientPage.email
        }
    }
}
</script>
